export default "__VITE_ASSET__52a5db34__$_?nuxt_component=async__"